import * as React from 'react'
import { css, SerializedStyles } from '@emotion/react'

type Props = {
  height: string
  width?: string
  color: string
  additionalStyles?: SerializedStyles
  onClick?: any
}

export const AddSignatureIcon = ({
  height = '20px',
  width,
  color,
  onClick = () => {},
  additionalStyles,
}: Props) => {
  return (
    <svg
      css={[
        css({ height: height, width: width ? width : 'auto', color: color }),
        additionalStyles,
      ]}
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M24.6589 31.9999C28.9565 31.9999 32.4404 28.5161 32.4404 24.2185C32.4404 19.9209 28.9565 16.437 24.6589 16.437C20.3613 16.437 16.8774 19.9209 16.8774 24.2185C16.8774 28.5161 20.3613 31.9999 24.6589 31.9999Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.1131 22.2222C17.3838 21.1986 17.8608 20.241 18.5148 19.4083C19.1687 18.5756 19.9859 17.8853 20.9162 17.3797C21.8465 16.8741 22.8702 16.5638 23.9247 16.468C24.9791 16.3721 26.042 16.4927 27.0482 16.8223V4.24621C27.0482 3.38526 26.7062 2.55957 26.0975 1.95079C25.4887 1.34201 24.663 1 23.802 1H4.23835C3.38553 1.002 2.56775 1.33953 1.96178 1.93961C1.35581 2.5397 1.01032 3.35415 1 4.20691V23.7863C1.00208 24.6445 1.34392 25.467 1.95078 26.0739C2.55764 26.6807 3.38012 27.0226 4.23835 27.0247H17.3961C16.7942 25.4945 16.6951 23.8124 17.1131 22.2222V22.2222Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.6587 20.7837V27.6534"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M21.2158 24.2185H28.0934"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.5911 16.8141H8.90963C9.13727 16.3683 9.3683 15.9042 9.59525 15.4312C10.6244 15.6037 11.8723 14.8526 13.3185 13.1903C13.5979 14.0314 14.1615 15.2431 15.1334 15.4271C15.8204 15.5573 16.5087 15.1763 17.2277 14.2685C17.6285 14.8253 18.5356 15.451 20.5911 15.451C20.6995 15.451 20.8035 15.4079 20.8802 15.3312C20.9569 15.2545 21 15.1505 21 15.0421C21 14.9336 20.9569 14.8296 20.8802 14.7529C20.8035 14.6762 20.6995 14.6332 20.5911 14.6332C17.8431 14.6332 17.7327 13.465 17.7286 13.3982C17.7267 13.3017 17.6907 13.2089 17.6269 13.1364C17.5632 13.0639 17.4758 13.0162 17.3803 13.002C17.2848 12.9877 17.1873 13.0077 17.1051 13.0583C17.0229 13.109 16.9614 13.1872 16.9313 13.2789C16.3002 14.2283 15.7175 14.7054 15.286 14.6236C14.9453 14.5595 14.5902 14.1377 14.289 13.4364C14.1254 13.0475 13.9966 12.645 13.9039 12.2335C13.8868 12.1505 13.8444 12.0749 13.7825 12.0171C13.7206 11.9592 13.6422 11.9221 13.5583 11.9107C13.4743 11.8993 13.3889 11.9143 13.3138 11.9536C13.2388 11.9928 13.1778 12.0544 13.1392 12.1299C11.8845 13.6906 10.7682 14.5643 9.97146 14.6277C11.5949 11.0783 12.0876 8.81969 11.4742 7.73469C11.2855 7.40074 10.8936 7 10.0955 7H10.0812C9.05889 7.00682 8.24855 8.00321 7.85326 9.73567C7.39186 11.7707 7.65289 14.2242 8.84284 15.1102C8.56001 15.6997 8.27036 16.275 7.98957 16.8141H6.41523C6.30678 16.8141 6.20277 16.8571 6.12608 16.9338C6.04939 17.0105 6.00631 17.1145 6.00631 17.223C6.00631 17.3314 6.04939 17.4354 6.12608 17.5121C6.20277 17.5888 6.30678 17.6319 6.41523 17.6319H7.55748C6.73214 19.1708 6.07446 20.2667 6.06492 20.2837C6.03533 20.3298 6.01528 20.3813 6.00597 20.4352C5.99665 20.4891 5.99826 20.5444 6.01069 20.5977C6.02312 20.651 6.04613 20.7013 6.07834 20.7455C6.11055 20.7898 6.15132 20.8271 6.19823 20.8553C6.24514 20.8835 6.29723 20.902 6.35142 20.9097C6.4056 20.9174 6.46078 20.9141 6.51369 20.9001C6.56659 20.8861 6.61614 20.8616 6.6594 20.828C6.70266 20.7945 6.73876 20.7526 6.76554 20.7049C6.77644 20.6872 7.55339 19.3916 8.48368 17.6319H20.5911C20.6995 17.6319 20.8035 17.5888 20.8802 17.5121C20.9569 17.4354 21 17.3314 21 17.223C21 17.1145 20.9569 17.0105 20.8802 16.9338C20.8035 16.8571 20.6995 16.8141 20.5911 16.8141ZM8.65338 9.91832C8.94371 8.64385 9.5087 7.81784 10.0955 7.81784C10.529 7.81784 10.6809 7.9889 10.7648 8.13748C11.0374 8.61455 11.1737 10.056 9.2061 14.3394C8.50276 13.6361 8.24105 11.7244 8.65338 9.91832Z"
        fill="#3980CE"
      />
    </svg>
  )
}
